// assets/hero-gallery.js
(function () {
  function init(scope) {
    const wrap  = (scope || document).querySelector('#heroGallery');
    if (!wrap) return;

    // prevent double init in Theme Editor
    if (wrap.dataset.hgi === '1') return;
    wrap.dataset.hgi = '1';

    const mainImg = wrap.querySelector('#hgMainImg');
    const nextImg = wrap.querySelector('#hgNextImg');
    const frame   = wrap.querySelector('.hg-main-frame');
    const track   = wrap.querySelector('[data-track]');
    const prev    = wrap.querySelector('.hg-arrow--prev');
    const next    = wrap.querySelector('.hg-arrow--next');
    if (!mainImg || !nextImg || !frame || !track || !prev || !next) return;

    const thumbs = Array.from(wrap.querySelectorAll('.hg-thumb'));
    if (!thumbs.length) return;

    /* ───────────── Helpers ───────────── */
    const currentIndex = () => thumbs.findIndex(t => t.classList.contains('is-active'));
    const setActive = (btn) => { thumbs.forEach(t => t.classList.remove('is-active')); btn.classList.add('is-active'); };
    const scrollThumbIntoView = (btn) => {
      const left = btn.offsetLeft, right = left + btn.offsetWidth;
      const visL = track.scrollLeft, visR = visL + track.clientWidth;
      if (left < visL || right > visR) track.scrollTo({ left: left - 8, behavior: 'smooth' });
    };
    const updateArrows = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    };
    const thumbStep = () => track.getBoundingClientRect().width / 4 + 8;
    const setMain = (url, alt) => { if (url) mainImg.src = url; if (alt) mainImg.alt = alt; };
    const activateThumb = (btn) => { setActive(btn); scrollThumbIntoView(btn); updateArrows(); };

    function showFromThumb(btn) {
      // Direct, no animation swap (used by clicks/variant sync)
      const url = btn.dataset.full;
      const childAlt = btn.querySelector('img')?.alt || '';
      setMain(url, childAlt);
      activateThumb(btn);
    }

    function gotoIndex(idx) {
      idx = Math.max(0, Math.min(idx, thumbs.length - 1));
      showFromThumb(thumbs[idx]);
    }

    /* ───────────── Thumbs (delegated click) ───────────── */
    track.addEventListener('click', (e) => {
      const btn = e.target.closest('.hg-thumb');
      if (btn) { e.preventDefault(); showFromThumb(btn); }
    });

    /* ───────────── Thumb-row arrows ───────────── */
    prev.addEventListener('click', () => track.scrollBy({ left: -thumbStep(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left:  thumbStep(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    window.addEventListener('load', updateArrows);
    updateArrows();

    /* ───────────── Drag with PREVIEW, no redundant slide ───────────── */
    let startX = null, startY = null, dx = 0, swipingH = false, animating = false;
    const SNAP  = 0.18;  // commit threshold (18% of width)
    const TRANS = 0.25;  // seconds

    // Reset preview layer
    function cleanPreview() {
      nextImg.classList.add('is-hidden');
      nextImg.style.transition = '';
      mainImg.style.transition = '';
      nextImg.style.transform = '';
      mainImg.style.transform = '';
    }

    function prepPreview(delta) {
      // delta: +1 = next (swipe left), -1 = prev (swipe right)
      const i = currentIndex();
      const target = i + delta;
      if (target < 0 || target > thumbs.length - 1) return false;
      const nextThumb = thumbs[target];
      nextImg.src = nextThumb.dataset.full;
      nextImg.alt = nextThumb.querySelector('img')?.alt || '';
      nextImg.classList.remove('is-hidden');
      // Place preview just offscreen ready
      nextImg.style.transform = `translateX(${delta > 0 ? 100 : -100}%)`;
      return true;
    }

    function onTouchStart(e) {
      if (animating) return;
      const t = e.touches[0];
      startX = t.clientX; startY = t.clientY; dx = 0; swipingH = false;
      frame.classList.add('is-dragging');
      cleanPreview(); // ensure fresh start
    }

    function onTouchMove(e) {
      if (animating || startX == null) return;
      const t = e.touches[0];
      const dy = Math.abs(t.clientY - startY);
      dx = t.clientX - startX;
      if (!swipingH && Math.abs(dx) > 14 && dy < 18) swipingH = true;
      if (!swipingH) return;

      e.preventDefault();

      const width = frame.offsetWidth;
      const delta = dx < 0 ? 1 : -1;  // left → next, right → prev
      const hasPreview = prepPreview(delta);

      const pct = (dx / width) * 100;
      // follow finger
      mainImg.style.transition = 'none';
      nextImg.style.transition = 'none';
      mainImg.style.transform = `translateX(${pct}%)`;
      if (hasPreview) {
        nextImg.style.transform = `translateX(${pct + (delta > 0 ? 100 : -100)}%)`;
      }
    }

    function onTouchEnd() {
      frame.classList.remove('is-dragging');
      if (animating || startX == null) return;

      const width = frame.offsetWidth;
      const threshold = width * SNAP;
      const delta = dx < 0 ? 1 : -1;   // left → next, right → prev
      const i = currentIndex();
      const target = i + delta;

      const committing = swipingH && Math.abs(dx) > threshold && target >= 0 && target <= thumbs.length - 1;

      if (committing) {
        // Finish the CURRENT slide only — no second slide after swap.
        animating = true;
        mainImg.style.transition = `transform ${TRANS}s ease`;
        nextImg.style.transition = `transform ${TRANS}s ease`;
        mainImg.style.transform = `translateX(${delta > 0 ? -100 : 100}%)`;
        nextImg.style.transform = `translateX(0)`; // preview finishes into place

        // After this one transition, swap src and reset instantly (no extra animation)
        setTimeout(() => {
          const nextThumb = thumbs[target];
          // Set main to final image (which is now visually centered via nextImg)
          setMain(nextThumb.dataset.full, nextThumb.querySelector('img')?.alt || '');
          activateThumb(nextThumb);

          // Instantly reset transforms and hide preview without animating again
          mainImg.style.transition = 'none';
          nextImg.style.transition = 'none';
          mainImg.style.transform = '';
          nextImg.style.transform = '';
          nextImg.classList.add('is-hidden');

          // Allow future gestures
          animating = false;
        }, TRANS * 1000);
      } else {
        // Not enough swipe or out of bounds → snap back both layers
        mainImg.style.transition = `transform ${TRANS}s ease`;
        nextImg.style.transition = `transform ${TRANS}s ease`;
        mainImg.style.transform = `translateX(0)`;
        nextImg.style.transform = `translateX(${delta > 0 ? 100 : -100}%)`;
        setTimeout(() => { cleanPreview(); }, TRANS * 1000);
      }

      // reset gesture state
      startX = null; startY = null; dx = 0; swipingH = false;
    }

    frame.addEventListener('touchstart', onTouchStart, { passive: true });
    frame.addEventListener('touchmove',  onTouchMove,  { passive: false });
    frame.addEventListener('touchend',   onTouchEnd,   { passive: true });

    /* ───────────── Variant → Image sync (no animation) ───────────── */
    const productScript = document.querySelector('[id^="product-json-"]');
    let product = null;
    try { product = productScript ? JSON.parse(productScript.textContent) : null; } catch (e) {}

    const findThumbByMediaId = (id) => thumbs.find(t => t.dataset.mediaId === String(id));
    const showVariantImageById = (variantId) => {
      if (!product || animating) return;
      const v = product.variants.find(x => String(x.id) === String(variantId));
      if (!v) return;
      const mediaId = v.featured_media?.id || v.featured_image?.id;
      if (!mediaId) return;
      const thumb = findThumbByMediaId(mediaId);
      if (thumb) showFromThumb(thumb);
    };

    const form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('product-form form');
    const idInput = form ? form.querySelector('input[name="id"]') : null;

    const onVariantChange = () => { if (idInput?.value) showVariantImageById(idInput.value); };
    idInput?.addEventListener('change', onVariantChange);
    idInput?.addEventListener('input', onVariantChange);
    document.addEventListener('variant:change', (e) => {
      const id = e?.detail?.variant?.id;
      if (id) showVariantImageById(id);
    }, true);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
